// src/api/stageActions.js
//
// createAndClaim() is for Permit specifically -- the one stage that's
// genuinely 0-or-1, so "claim it" when none exists yet has to create the
// row first. Rather than making that a two-step (fill in a details form,
// submit, then separately click Claim), this does both in one call: POST
// an empty row, then immediately POST claim/ on it. Used by both
// StageCard's "no permit yet" state and ProjectListPage's inline claim
// button, so the two surfaces can't drift apart.

import { apiFetch } from "./client";

export async function createAndClaim(basePath, projectId) {
  await apiFetch(`${basePath}/`, {
    method: "POST",
    body: JSON.stringify({ project: projectId }),
  });
  return apiFetch(`${basePath}/${projectId}/claim/`, { method: "POST" });
}
